import { getGlobalStore } from '../store';
import { updateItemsMediaUsage } from '../util/mediaUsages';
import { evalScript } from './cep';
import type { NleProjectBin } from '@mimir/primitive/nle/bin';
import type { ImportToNleParams } from '@mimir/primitive/nle/import';
import { getPathForScript } from './misc';
import { isInPremiere, type AdobePanelContext, type ElectronContext, isInElectron, isInAdobeApp } from '@mimir/common/context/applicationContext';

export async function importToPremiereAsync(applicationContext: AdobePanelContext | ElectronContext, importParams: ImportToNleParams, shouldUsePremierePreferences: boolean, targetBin?: NleProjectBin, newSequenceName?: string): Promise<void> {
  if (isInPremiere(applicationContext)) {
    await batchImportToPremierePromise(applicationContext, [importParams], shouldUsePremierePreferences, targetBin, newSequenceName);
  } else {
    if (isInAdobeApp(applicationContext)) {
      evalScript(`importFile("${getPathForScript(applicationContext, importParams.filePath)}", ${JSON.stringify(importParams.title)}, "", "", "", "", "", "", "", ${shouldUsePremierePreferences})`);
    } else if (getGlobalStore().getters.dvrMode) {
      await applicationContext.cepBridgeClient.call('importToDvr', importParams);
    }
    if (importParams.sourceItemId) {
      await updateItemsMediaUsage([importParams.sourceItemId], { lastUsedWorkflow: isInElectron(applicationContext) ? 'desktop_download' : 'import' });
    }
  }
}


export async function batchImportToPremierePromise(
  applicationContext: AdobePanelContext | ElectronContext,
  importParams: ImportToNleParams[],
  shouldUsePremierePreferences: boolean,
  targetBin?: NleProjectBin,
  newSequenceName?: string,
  onCompleted?: () => void,
  onError?: () => void,
  updateItemsMediaUsageFn = updateItemsMediaUsage,
) {
  const itemIds = new Set<string>();
  importParams.forEach(item => {
    if (item.sourceItemId) itemIds.add(item.sourceItemId);
  });
  await updateItemsMediaUsageFn(Array.from(itemIds), { lastUsedWorkflow: isInElectron(applicationContext) ? 'desktop_download' : 'import' });
  if (isInPremiere(applicationContext) || (isInElectron(applicationContext) && applicationContext.dvrMode)) {
    try {
      const cepb = applicationContext.cepBridgeClient;
      await cepb.call('batchImportFiles', importParams, targetBin, newSequenceName, shouldUsePremierePreferences);
      if (onCompleted) {
        onCompleted();
      }
    } catch (err) {
      if (onError) {
        onError();
      }
      throw err;
    }
  } else {
    // TODO: For whatever reason we end up all the way down here when in
    // Mimir desktop even though batch import makes no sense in this context.
    // For now in order to make notifications go away etc we need to just
    // pretend that batch import succeeded.
    if (onCompleted) onCompleted();
  }
}
